module.exports = __webpack_public_path__ + "personanatural.png?b7916691d075a41f7ca22061acd89835";


//////////////////
// WEBPACK FOOTER
// ./src/assets/personanatural.png
// module id = 659
// module chunks = 0 2 7 8 9 10 21